import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface VoucherVariant {
  price_id: string;
  title: string;
  amount: string;
  quantity: number;
}
interface VoucherCartItem {
  voucher_name: string;
  voucher_id: string;
  store_name: string;
  store_id: string;
  variant: VoucherVariant;
}

// Cart item structure
export interface CartItem {
  id: string | number;
  module: "voucher" | "product" | string; // extendable for future modules
  [key: string]: any; // flexibility for extra props (e.g., name, price, image)
}

// Cart context state
interface CartContextType {
  open: boolean;
  cartModule: string | null;
  showCart: (pathname?: string) => void;
  hideCart: () => void;
  items: CartItem[];
  activeModule: string | null;
  setCartModule: Dispatch<SetStateAction<string | null>>;
  setActiveModule: Dispatch<SetStateAction<string | null>>;
  // addToCart: (item: CartItem) => void;
  // removeFromCart: (id: string | number, module: string, type?: string) => void;
  // clearCart: (module?: string) => void;
}

// Create context
const CartContext = createContext<CartContextType | undefined>(undefined);

// Provider
export const CartProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [cartModule, setCartModule] = useState<string | null>(null);
  const [items, setItems] = useState<CartItem[]>([]);
  const [activeModule, setActiveModule] = useState<string | null>(null);

  const showCart = (pathname?: string) => {
    console.log("check partname ===> ", pathname?.includes("voucher"));
    setOpen(true);
    setCartModule(`${pathname}`);
  };
  const hideCart = () => setOpen(false);

  // const addToCart = (item: CartItem) => {
  //   setItems((prev) => {
  //     const existing = prev.find(
  //       (p) =>
  //         p.id === item.id &&
  //         p.module === item.module &&
  //         (p.type ? p.type === item.type : true)
  //     );

  //     if (existing) {
  //       return prev.map((p) =>
  //         p.id === item.id && p.module === item.module && p.type === item.type
  //           ? { ...p, qty: p.qty + item.qty }
  //           : p
  //       );
  //     }
  //     return [...prev, item];
  //   });

  //   // Automatically switch to this module when adding an item
  //   if (!activeModule) setActiveModule(item.module);
  // };

  // const removeFromCart = (
  //   id: string | number,
  //   module: string,
  //   type?: string
  // ) => {
  //   setItems((prev) =>
  //     prev.filter(
  //       (p) =>
  //         !(
  //           p.id === id &&
  //           p.module === module &&
  //           (type ? p.type === type : true)
  //         )
  //     )
  //   );
  // };

  // const clearCart = (module?: string) => {
  //   if (module) {
  //     setItems((prev) => prev.filter((p) => p.module !== module));
  //   } else {
  //     setItems([]);
  //     setActiveModule(null);
  //   }
  // };

  return (
    <CartContext.Provider
      value={{
        open,
        cartModule,
        setCartModule,
        showCart,
        hideCart,
        items,
        activeModule,
        setActiveModule,
        // addToCart,
        // removeFromCart,
        // clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

// Hook
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
